import { type WebOpportunity } from '../../../lib/opportunities';
import { OpportunityDeck } from './OpportunityDeck';
import { OpportunityFanDeck } from './OpportunityFanDeck';

// The home's opportunities section, in two renderings of the SAME data — mirroring `PiledUpJobs`, and
// switched at the SAME moment the band restacks to a single column. `narrow` comes DOWN from
// `CatchUpSections` for the reason spelled out in `PiledUpJobs`: the band stacks on its own width, not
// the window's, so a `matchMedia` query here disagreed with the row around it.
//
//   • wide (desktop) → the horizontal left-fan `OpportunityFanDeck` (no header, receding grey cards).
//   • narrow (mobile) → the vertical peek-stack `OpportunityDeck` (header + subtitle).
//
// Both show at most three cards and open the full list in `OpportunitiesModal` from "View More".

interface Props {
  opportunities: WebOpportunity[];
  /** The band has stacked to one column — see the note above. Measured by `CatchUpSections`. */
  narrow: boolean;
  /** Resolves the card's eyebrow — the owning workspace's name (the pile aggregates every workspace). */
  workspaceName: (opportunity: WebOpportunity) => string | undefined;
}

export function OpportunityPile({ narrow, ...props }: Props) {
  return narrow ? <OpportunityDeck {...props} /> : <OpportunityFanDeck {...props} />;
}
